<template>
  <Spinner v-if="sessionStore.isLoading" />
  <div id="bst-wrap">
    <div class="l-project-wrap l-project-wrap--login">
      <!-- header -->
      <section class="l-content-area">
        <div class="l-content">
          <section class="p-bloc p-bloc--login">
            <div class="p-bloc__content l-wrap__outer">
              <div class="l-wrap__inner">
                <!-- <h1>ログイン</h1> -->
                <div class="login-box">
                  <div class="p-login__title">
                    <div class="logo"><img src="@/assets/img/login/logo.png" alt="hubsynch"></div>
                    <h1>{{ $t("LOGIN_TITLE") }}</h1>
                  </div>
                  <section class="p-login c-register-parts">
                    <p>{{ $t("LOGIN_TEXT_1") }}<br>
                      {{ $t("LOGIN_TEXT_2") }}</p>
                    <form @submit.prevent="logIn()">
                      <div class="p-login__form">
                        <div class="mailaddress">
                          <div class="input-area"
                            :class="{ 'is-error': v$.email.$error || sessionStore.loginErrors.email || sessionStore.loginErrorMsg }">
                            <!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                            <input id="input-email" type="email" name="email" class="plchldr"
                              :placeholder="$t('LABEL_EMAIL')" v-model="sessionStore.email">
                          </div>
                          <p class="error-txt" v-if="v$.email.$errors[0]">{{ $t(v$.email.$errors[0].$message) }}</p>
                          <p class="error-txt" v-if="sessionStore.loginErrors.email">{{ $t('TEXT_MEMBER_NOT_FOUND') }}
                          </p>
                        </div>
                        <div class="password">
                          <div class="password-area"
                            :class="{ 'is-error': v$.password.$error || sessionStore.loginErrors.password || sessionStore.loginErrorMsg }">
                            <!-- TODO: When there is an error, add "is-error" class to this "div.password-area" -->
                            <input id="input-password" type="password" name="password" class="plchldr"
                              :placeholder="$t('LABEL_PASSWORD')" v-model="sessionStore.password">
                            <div class="eye-btn"><a class="" href="#" aria-label="eye"></a></div>
                          </div>
                          <p class="error-txt" v-if="v$.password.$errors[0]">{{ $t(v$.password.$errors[0].$message) }}
                          </p>
                          <p class="error-txt" v-if="sessionStore.loginErrors.password">{{
                            $t('LOGIN_WRONG_PASSWORD_MESSAGE') }}</p>
                          <p class=" error-txt" v-if="sessionStore.loginErrorMsg">{{ sessionStore.loginErrorMsg }}</p>
                        </div>
                        <div v-if="sessionStore.loginErrorMsg" class="login-note">
                          <span class="login-note__icon">ⓘ</span>

                          <p class="login-note__text" v-html="$t('ERROR_LOGIN_EMAIL_NOT_VERIFIED')"></p>
                        </div>
                        <p class="reminder"><a id=link-remind-password href="/reminder">{{ $t("LABEL_FORGET_PASSWORD")
                            }}</a></p>
                        <div class="c-btn c-btn--login"><input id="button-login" type="submit"
                            :value="$t('LABEL_BUTTON_LOGIN')"></div>
                      </div>
                      <!-- <div class="p-login__registration">
                        <h3>{{ $t('LABEL_SIGN_UP') }}</h3>
                        <div class="c-btn c-btn--registration">
                          <router-link :to="{ name: 'register.agreement' }">
                            <input id=link-registration type="button" :value="$t('TEXT_SIGN_UP')">
                          </router-link>
                        </div>
                      </div> -->
                    </form>
                  </section>
                </div><!-- .bg-box -->
              </div>
            </div>
          </section>
        </div><!-- .l-content -->
      </section><!-- .l-content-area -->
    </div><!-- .l-project-wrap -->
    <!-- footer -->
  </div>
</template>

<script setup>
import { useSessionStore } from "@/stores/sessionStore";
import { useUserStore } from "@/stores/userStore";
import { useRouter } from "vue-router";
import Spinner from "@/components/Spinner.vue";
import { useVuelidate } from '@vuelidate/core';
import { getLoginRules } from "@/validations/loginValidation";
import { onMounted } from 'vue'
import { initializeLogin } from "@/assets/js/entries/login.js";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const sessionStore = useSessionStore();

const v$ = useVuelidate(getLoginRules(t), sessionStore);

const router = useRouter();

async function logIn() {
    if (!await v$.value.$validate()) {
        return false;
    }
    document.cookie = "hvc-cookie=50;path=/;domain=hubsynch.com";

    if (await sessionStore.logIn()) {
        if (await useUserStore().isValidUserInfo()) {
            await router.push({ name: "top.page" });
        } else {
            await router.push({ name: "edit.account" });
        }
    }
}

onMounted(() => {
    initializeLogin();
})
</script>

<style lang="scss" scoped>
.login-note {
  display: flex;
  align-items: flex-start;
  gap: 10px;

  margin-top: 14px;
  padding: 12px 14px;

  border: 1px solid #b9d7ff;
  border-radius: 8px;

  background-color: #f4f9ff;
}

.login-note__icon {
  flex-shrink: 0;

  font-size: 16px;
  line-height: 1;

  color: #3b82f6;
  margin-top: 2px;
}

.login-note__text {
  margin: 0;

  color: #2c3e50;
  font-size: 14px;
  line-height: 1.6;
}
</style>